import {
  addActivityPlan,
  deleteActivityPlan,
  getAllSplitActivityPlan,
  getActivityPlanByDateRange,
  getActivityPlanInfo,
  updateActivityPlan,
} from '@/_serveice/performance/activityPlan';

export default {
  namespace: 'activityPlan',

  state: {
    // 活动计划列表
    planList: [],
    searchForm: {},
  },

  effects: {
    // 根据日期范围查询活动计划
    *getActivityPlanByDateRange({ payload, reset }, { put, call, select }) {
      const searchData = yield select(
        ({ activityPlan }) => activityPlan.searchForm,
      );
      let searchForm = { ...searchData, ...payload };
      if (reset) {
        searchForm = payload;
      }
      const res = yield call(getActivityPlanByDateRange, searchForm);
      if (res?.success) {
        yield put({
          type: 'save',
          payload: {
            planList: res.data,
            searchForm,
          },
        });
        return res.data;
      }
    },

    // 查询所有活动计划（拆分）
    *getAllSplitActivityPlan({ payload }, { put, call }) {
      const res = yield call(getAllSplitActivityPlan, payload);
      if (res?.success) {
        yield put({
          type: 'save',
          payload: {
            planList: res.data || [],
          },
        });
        return res.data;
      }
    },

    // 新增活动计划
    *addActivityPlan({ payload }, { put, call }) {
      const res = yield call(addActivityPlan, payload);
      if (res?.success) {
        return true;
      }
    },

    // 修改活动计划
    *updateActivityPlan({ payload }, { put, call }) {
      const res = yield call(updateActivityPlan, payload);
      if (res?.success) {
        return true;
      }
    },

    // 删除活动计划
    *deleteActivityPlan({ payload }, { put, call }) {
      const res = yield call(deleteActivityPlan, payload);
      if (res?.success) {
        return true;
      }
    },

    // 查询活动计划详情
    *getActivityPlanInfo({ payload }, { put, call }) {
      const res = yield call(getActivityPlanInfo, payload);
      if (res?.success) {
        return res.data;
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
